import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import PanelTemplate from "../../../templates/Panel";
import GestaoSettingsTabs from "../../../components/GestaoSettingsTabs";
import Box from "../../../components/Box";
import Toggle from "../../../components/Toggle";

import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";
import { hasPermission } from "../../../services/auth";

// Liga e desliga as ações que o financeiro executa sozinho (BDM-1045).
// O texto de cada automação vem do backend: a mesma lista vale para a tela,
// o suporte e os testes.
export const FinanceAutomations = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(null);
    const [automations, setAutomations] = useState([]);

    const canManage = hasPermission('manage_finance_automation');

    useEffect(() => {
        getAutomations();
    }, []);

    const getAutomations = () => {
        setLoading(true);

        api.get(`/finance-automation`).then(res => {
            setAutomations(res.data.resources);
        }).catch(renderError).then(() => setLoading(false));
    };

    const toggle = (automation, isActive) => {
        setSaving(automation.key);
        setAutomations(current => current.map(item => (
            item.key === automation.key ? { ...item, is_active: isActive } : item
        )));

        api.put(`/finance-automation/${automation.key}`, { is_active: isActive }).then(() => {
            toast.success(isActive ? `Automação ativada` : `Automação desativada`);
        }).catch(error => {
            renderError(error);
            setAutomations(current => current.map(item => (
                item.key === automation.key ? { ...item, is_active: !isActive } : item
            )));
        }).then(() => setSaving(null));
    };

    const groups = automations.reduce((accumulator, automation) => ({
        ...accumulator,
        [automation.group]: [...(accumulator[automation.group] ?? []), automation]
    }), {});

    return (
        <PanelTemplate id="finance-automations">
            <GestaoSettingsTabs />

            <Box>
                <p className={`finance-automations-hint`}>
                    O que estiver ligado acontece sozinho, sem ninguém precisar clicar. Desligar
                    não desfaz o que já foi gerado e não tira o botão da tela — só deixa de
                    disparar automaticamente.
                </p>

                {loading &&
                    <div className={`finance-automations-empty`}>Carregando...</div>
                }

                {!loading && automations.length === 0 &&
                    <div className={`finance-automations-empty`}>
                        Nenhuma automação disponível.
                    </div>
                }

                {!loading && Object.keys(groups).map(group => (
                    <div className={`finance-automations-group`} key={group}>
                        <span className={`finance-automations-group-title`}>{group}</span>

                        {groups[group].map(automation => (
                            <div className={`finance-automations-row`} key={automation.key}>
                                <div>
                                    <strong>{automation.label}</strong>
                                    <span>{automation.description}</span>
                                </div>
                                <Toggle
                                    checked={automation.is_active === true}
                                    onChange={value => toggle(automation, value)}
                                    disabled={!canManage || saving === automation.key}
                                    label={automation.label}
                                />
                            </div>
                        ))}
                    </div>
                ))}

                {!loading && !canManage &&
                    <p className={`finance-automations-hint`}>
                        Você pode ver como está configurado, mas alterar as automações depende da
                        permissão de gerenciá-las.
                    </p>
                }
            </Box>
        </PanelTemplate>
    );
};

export default FinanceAutomations;
